import PropTypes from "prop-types";

import ContentVeil from "@/components/ContentVeil";
import getUserProperties from "@/users/getUserProperties";
import SecondaryActionsToolbar from "@/view/SecondaryActionsToolbar/SecondaryActionsToolbar";
import usePresentModeContext from "@/view/utils/usePresentModeContext";
import useViewportIsNotDesktop from "@/view/utils/useViewportIsNotDesktop";
import ContentDisplayDetails from "../ContentDisplayDetails";
import VideoBody from "../VideoBody";
import VideoMobilePresentModeQuiz from "../VideoMobilePresentModeQuiz";
import VideoTranscript from "../VideoTranscript";
import CollapsibleTranscript from "./CollapsibleTranscript";
import { rootCss, detailsRootCss } from "./VideoDisplay.style";

const propTypes = {
  user: PropTypes.object,
  content: PropTypes.object,
  contentMetadata: PropTypes.object,
  matchedAssignments: PropTypes.array,
  bannerMode: PropTypes.shape({
    isBannerModeActive: PropTypes.bool.isRequired,
  }),
};
const VideoDisplay = ({
  bannerMode,
  content,
  contentMetadata,
  matchedAssignments,
  user,
}) => {
  const contentData = content?.data;
  const { isVideoPresentModeActive, isVideoPresentModeWithoutQuiz } =
    usePresentModeContext();
  const activitiesPanelIsAtBottomOfPage = useViewportIsNotDesktop();

  const mobileVideoPresentModeIsActive =
    isVideoPresentModeActive && activitiesPanelIsAtBottomOfPage;
  const showMobilePresentModeQuiz =
    mobileVideoPresentModeIsActive && !isVideoPresentModeWithoutQuiz;

  const userProperties = getUserProperties(user);
  const { isTeacher, isStudent, isLiteUser } = userProperties;
  const onlyLiteUsers = isLiteUser && !isStudent;
  const isVideoBlocked = onlyLiteUsers && !content.data.is_lite;

  const renderTranscript = () => {
    if (isVideoBlocked) {
      return <ContentVeil />;
    }
    if (isStudent) {
      return <VideoTranscript contentId={content?.id} />;
    }
    return <CollapsibleTranscript contentId={content.id} />;
  };
  return (
    <div css={rootCss}>
      <VideoBody
        content={content}
        isVideoPresentModeActive={isVideoPresentModeActive}
        user={user}
        showVeil={isVideoBlocked}
      />
      {isVideoPresentModeActive ? null : (
        <ContentDisplayDetails
          __cssFor={{ root: detailsRootCss }}
          bannerMode={bannerMode}
          contentData={contentData}
          contentMetadata={contentMetadata}
          isStudent={isStudent}
          isTeacher={isTeacher}
        />
      )}
      <SecondaryActionsToolbar
        bannerMode={bannerMode}
        content={content}
        matchedAssignments={matchedAssignments}
        user={user}
        userProperties={userProperties}
      />
      {showMobilePresentModeQuiz ? <VideoMobilePresentModeQuiz /> : null}
      {renderTranscript()}
    </div>
  );
};

VideoDisplay.propTypes = propTypes;

export default VideoDisplay;
